import { useTranslation } from "react-i18next";
import Status from "../../../../enums/Status";
import { Alert, Col, ListGroup, Row, Spinner } from "react-bootstrap";
import { formatDate } from "../../../../utils/DateUtils";
import IInviteRecord from "../../../../models/invite/IInviteRecord";
import InviteStatusBadge from "./InviteStatusBadge";
import AccessStatus from "./AccessStatus";
import { InviteListItem } from "./InviteListItem";

interface IInviteListProps {
    invites: IInviteRecord[];
    status: Status;
}

const InviteList = (props: IInviteListProps) => {
    const { t } = useTranslation();

    if (props.status === Status.LOADING) {
        return (
            <div className="text-center py-4">
                <Spinner />
                <span className="d-block mt-2 fw-bold">
                    {t("it.invite.history.loading")}
                </span>
            </div>
        );
    }

    if (props.status === Status.LOAD_ERROR) {
        return (
            <Alert variant="danger">
                {t("it.invite.history.errors.general")}
            </Alert>
        );
    }

    if (props.invites.length === 0) {
        return (
            <Alert variant="info" className="mb-0">
                {t("it.invite.history.errors.none")}
            </Alert>
        );
    }

    return (
        <ListGroup variant="flush">
            <ListGroup.Item className="d-none d-lg-block">
                <Row>
                    <Col lg={3} className="fw-bold">
                        {t("it.invite.history.table.headers.name")}
                    </Col>
                    <Col lg={3} className="fw-bold">
                        {t("it.invite.history.table.headers.email")}
                    </Col>
                    <Col lg={2} className="fw-bold">
                        {t("it.invite.history.table.headers.invited")}
                    </Col>
                    <Col lg={2} className="fw-bold">
                        {t("it.invite.history.table.headers.status")}
                    </Col>
                    <Col lg={2} className="fw-bold">
                        {t("it.invite.history.table.headers.access")}
                    </Col>
                </Row>
            </ListGroup.Item>

            {
                props.invites.map(invite => <InviteListItem key={invite.id} invite={invite} />)
            }
        </ListGroup>
    );
};

export default InviteList;